import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Button, Chip, Grid, Typography } from "components/controls/widget";
import * as moment from "moment";
import { Payment, PaymentState } from "common/api/Payments";

interface SeznamPlatebItemProps {
    payment: Payment;
    showPaymentInfo: (p: Payment) => void;
    paymentInfoIsVisible: boolean;
}


class SeznamPlatebItem extends React.PureComponent<SeznamPlatebItemProps & WithStyles<typeof styles>> {

    getDate = (date: Date) => {
        return moment(date).format('D. M. YYYY');
    }
    render() {
        const { classes, payment, showPaymentInfo, paymentInfoIsVisible } = this.props;
        const item = payment.items[0];
        const showItem = payment.state !== PaymentState.Created;

        return showItem ? <Grid item>
            <Grid container spacing={8} justify="flex-start" alignItems="center" className={classes.root}>
                <Grid item md={2}><Typography variant="subtitle2" align="right">{this.getDate(payment.sendDate)}</Typography></Grid>
                <Grid item md={4}><Typography variant="subtitle2">{`Příspěvky pro rok ${payment.year}`}</Typography></Grid>
                <Grid item md={3}><Typography variant="subtitle2" align="right">{`${payment.amount} Kč`}</Typography></Grid>
                <Grid item md={3} className={classes.button}>
                    {payment.state === PaymentState.Sended
                        ? <Button variant="contained" size="small" onClick={() => showPaymentInfo(payment)} disabled={paymentInfoIsVisible}>{'Platební údaje'}</Button>
                        : payment.state === PaymentState.Accepted
                            ? <Chip classes={{ colorPrimary: classes.chipSuccess }} color="primary" label={'zpracováno'} />
                            : payment.state === PaymentState.Storno ? <Chip color="secondary" label={'stornováno'} />
                                : null}
                </Grid>
            </Grid>
        </Grid> : null;
    }
}


const styles = (theme: Theme) => createStyles({
    root: {
        paddingTop: 4,
        paddingBottom: 4,
        backgroundColor: 'aliceblue'
    },
    button: {
        textAlign: 'right'
    },
    chipSuccess: {
        color: '#fff',
        backgroundColor: theme.palette.success.main,
    },
});


export default withStyles(styles)(SeznamPlatebItem);
